(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const requestedProduct = new URLSearchParams(window.location.search).get('product');
  const productField = document.getElementById('ContactForm-product');
  if (requestedProduct && productField) productField.value = requestedProduct.slice(0, 200);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  const viewportObservers = new Map();
  let slideshowPointerStart = null;
  const slideshowClickTimes = new WeakMap();

  document.addEventListener('pointerdown', (event) => {
    const slideshow = event.target.closest('slideshow-component[data-fit-viewport]');
    slideshowPointerStart = slideshow ? { slideshow, x: event.clientX, y: event.clientY } : null;
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const pointerStart = slideshowPointerStart;
    slideshowPointerStart = null;
    const slide = event.target.closest('slideshow-component[data-fit-viewport] .slideshow__slide');
    if (!slide || window.Shopify?.designMode || event.defaultPrevented || event.button !== 0) return;
    if (event.target.closest('a, button, input, select, textarea, summary, [role="button"], [contenteditable]')) return;
    if (window.getSelection()?.toString()) return;

    const slideshow = slide.closest('slideshow-component');
    // A swipe already moves the native slider; only a stationary click/tap advances it again.
    if (pointerStart?.slideshow === slideshow &&
        Math.hypot(event.clientX - pointerStart.x, event.clientY - pointerStart.y) > 10) return;
    const now = performance.now();
    if (now - (slideshowClickTimes.get(slideshow) ?? -Infinity) < 500) return;
    slideshowClickTimes.set(slideshow, now);
    slideshow.querySelector('button[name="next"]')?.click();
  });

  function fitHomepageSlideshow() {
    viewportObservers.forEach((observer) => observer.disconnect());
    viewportObservers.clear();

    document.querySelectorAll('slideshow-component[data-fit-viewport]').forEach((slideshow) => {
      const chrome = [...document.querySelectorAll('.shopify-section-group-header-group')];
      const controls = slideshow.querySelector('.slideshow__controls');
      if (controls) chrome.push(controls);

      const update = () => {
        const height = chrome.reduce((total, element) => total + element.getBoundingClientRect().height, 0);
        slideshow.style.setProperty('--slideshow-chrome-height', `${height}px`);
      };

      const observer = new ResizeObserver(update);
      chrome.forEach((element) => observer.observe(element));
      viewportObservers.set(slideshow, observer);
      update();
    });
  }

  fitHomepageSlideshow();
  document.addEventListener('shopify:section:load', fitHomepageSlideshow);
  document.addEventListener('shopify:section:unload', (event) => {
    viewportObservers.forEach((observer, slideshow) => {
      if (event.target.contains(slideshow)) {
        observer.disconnect();
        viewportObservers.delete(slideshow);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
